import axios from '@axios';

const base = '/api/v1/visits';
const baseFeedback = '/api/v1/prisoner-feedback/';

export default {
  getVisits(prisonerNumber) {
    return axios.get(`${base}/prisoner/${prisonerNumber}`);
  },
  getVisit(id) {
    return axios.get(`${base}/single-visit/${id}`);
  },
  sendReminderToVisitor(visitId, data) {
    return axios.post(`${base}/remind/visitor/${visitId}`, data);
  },
  sendRating(visitId, reason, rating) {
    return axios.post(`${baseFeedback}`, { reason, rating, visit_id: visitId });
  },
  // updateWaitingRoomStatus(callId, status) {
  //   return axios.post(`${base}/call-state/set-visitor-in-waiting-room/${callId}`, status);
  // },
};
